<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-08-12 10:58:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-05 15:23:10
-->
<template>
  <span>
    <el-select v-if="allowField.includes('companyId')" v-model="companyId" @change="companyChange" filterable clearable class="seliput settlement">
      <el-option label="全部公司范围" value=""></el-option>
      <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-if="allowField.includes('settlementId')" v-model="settlementId" @change="settlementChange" filterable clearable class="seliput settlement">
      <el-option label="全部服务公司范围" value=""></el-option>
      <el-option
        v-for="item in settlementList"
        :key="item.id"
        :label="item.channel_name"
        :value="item.channel_account">
      </el-option>
    </el-select>
    <el-select v-if="allowField.includes('cardAttribute')" v-model="cardAttribute" @change="cardAttributeChange" filterable clearable class="seliput settlement">
      <el-option label="全部提现类型" value=""></el-option>
      <el-option label="对私提现" value="C"></el-option>
      <el-option label="对公提现" value="B"></el-option>
    </el-select>
    <el-select v-if="allowField.includes('sendStatus')" v-model="sendStatus" @change="sendStatusChange" filterable clearable class="seliput settlement">
      <el-option label="全部发放状态" value=""></el-option>
      <el-option label="待发放" value="00"></el-option>
      <el-option label="已发放" value="11"></el-option>
      <el-option label="发放失败" value="02"></el-option>
    </el-select>
  </span>
</template>

<script>
import api from '@/api'

export default {
  props: {
    allowField: {
      type: Array,
      default: () => [
        'companyId',
        'settlementId'
      ],
      required: false
    },
  },
  data() {
    return {
      companyId: '',
      settlementId: '',
      cardAttribute: '',
      sendStatus: '',
      companyList: [],
      settlementList: [],
    };
  },
  inject: ["reload"],
  async mounted() {
    let result = await api.getUserCompanyList()
    let result2 = await api.tenantCategoryList()
    this.companyList = result
    this.settlementList = result2
  },
  methods: {
    // 公司选择
    async companyChange(v) {
      this.companyId = v
      let name = 'company'
      this.$emit('ScreeCompany', v, name)
    },
    // 服务公司选择
    async settlementChange(v) {
      this.settlementId = v
      let name = 'settlement'
      this.$emit('ScreeCompany', v, name)
    },
    // 卡属性选择
    async cardAttributeChange(v) {
      this.cardAttribute = v
      let name = 'cardAttribute'
      this.$emit('ScreeCompany', v, name)
    },
    // 发放状态选择
    async sendStatusChange(v) {
      this.sendStatus = v
      let name = 'sendStatus'
      this.$emit('ScreeCompany', v, name)
    },
  }
};
</script>

<style lang="stylus" scoped>
.seliput/deep/.el-input__inner
  height: 36px
  line-height: 36px
.search-btn
  margin-left: -35px
  margin-top: 1px
.settlement
  margin-right: 10px
</style>